export default __webpack_public_path__ + "static/media/help.f2471d89.svg";